import React,{ type ReactNode } from 'react';
import { getCurrentVariantConfig,getSiteVariant,SiteVariantType } from '../config/siteVariants';
import { SiteVariantContext } from './SiteVariantContext.shared';

export const SiteVariantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const variant = getSiteVariant();
    const config = getCurrentVariantConfig();

    const value = {
        variant,
        config,
        isMain: variant === SiteVariantType.MAIN,
    };

    return (
        <SiteVariantContext.Provider value={value}>
            {children}
        </SiteVariantContext.Provider>
    );
};
